<template>
  <div>
    <b-card title="">
      <b-card-header>
        <span class="d-flex align-items-center">
          <feather-icon icon="SettingsIcon" size="20" />
          <h2 class="mb-0 ml-50">Configurações</h2>
        </span>
      </b-card-header>
      <b-row class="my-1 ml-50 text-left mt-2 d-flex align-items-center">
        <b-col cols="12" md="6">
          <b-form-checkbox
            v-model="item.integration"
            name="check-button"
            switch
          >
            Integração com V-QUALITY
          </b-form-checkbox>
        </b-col>
        <b-col v-if="item.integration == true" cols="12" md="6">
          <b-form-group>
            <label class="text-center font-weight-bold text-primary"
              >Id de integração (company_id)</label
            >
            <b-form-input
              type="text"
              v-model="item.quality_id"
              maxlength="36"
              @input="
                item.quality_id = item.quality_id.replace(/[^a-zA-Z0-9-]/g, '')
              "
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1 ml-50 text-left mt-2 d-flex align-items-center">
        <b-col cols="12" md="6">
          <b-form-checkbox v-model="create_task" name="check-button" switch>
            Limitar criar tarefa
          </b-form-checkbox>
        </b-col>
        <b-col v-if="create_task" cols="12" md="6">
          <b-form-group>
            <label class="text-center font-weight-bold text-primary"
              >Intervalo permitido em dias</label
            >
            <b-form-input
              v-model="item.prevent_create_task"
              v-mask="'###'"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label class="text-center font-weight-bold text-primary"
              >Controle Especial</label
            >
            <b-form-checkbox
              v-model="item.manager_bypass"
              name="check-button"
              switch
            >
              Permitir que os gerentes ultrapassem esta regra
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1 ml-50 text-left mt-2 d-flex align-items-center">
        <b-col cols="12" md="6">
          <b-form-checkbox v-model="two_steps" name="check-button" switch>
            Senha numerica de 2 etapas
          </b-form-checkbox>
        </b-col>
        <b-col v-if="two_steps" cols="12" md="6">
          <b-form-input
            v-model="item.two_step_passwords"
            type="text"
            maxlength="6"
            placeholder="******"
            v-mask="'######'"
            class="text-center"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row class="justify-content-end">
        <b-col cols="auto" class="text-right">
          <b-button variant="primary" @click="saveConfig">Salvar </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BCardHeader,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BRow,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  name: '',
  components: {
    BCard,
    BRow,
    BCol,
    BCardHeader,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BButton,
  },
  mixins: [],
  props: {},
  data() {
    return {
      item: {
        integration: false,
        quality_id: '',
        prevent_create_task: '',
        manager_bypass: false,
        two_step_passwords: '',
        two_steps: false,
      },
      days: [2, 3, 4, 5, 6, 7],
      create_task: false,
      two_steps: false,
    };
  },

  watch: {
    create_task(val) {
      if (val == false) {
        this.item.prevent_create_task = null;
      }
    },
    two_steps(val) {
      if (val == false) {
        this.item.two_step_passwords = null;
        this.item.two_steps = false;
      }
      if (val == true) {
        this.item.two_steps = true;
      }
    },
  },
  computed: {
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      console.log(this.currentWorkspace);
      if (this.currentWorkspace?.quality_id) {
        this.item.integration = true;
        this.item.quality_id = this.currentWorkspace.quality_id;
      }

      if (this.currentWorkspace?.prevent_create_task) {
        this.create_task = true;
        this.item.prevent_create_task =
          this.currentWorkspace.prevent_create_task;
        this.item.manager_bypass = this.currentWorkspace.manager_bypass;
      }

      if (this.currentWorkspace?.two_steps) {
        this.two_steps = true;
      }
    },
    saveConfig() {
      const body = {
        ...this.item,
        prevent_create_task:
          this.item?.prevent_create_task === ''
            ? 1
            : this.item?.prevent_create_task,
        workspace_id: this.currentWorkspace.id,
      };
      this.$store
        .dispatch('saveWorkspaceConfig', body)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Configurações salvas',
              icon: 'CheckIcon',
              text: 'Workspace Atualizado',
              variant: 'success',
            },
          });
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao salvar',
              icon: 'XIcon',
              text: err ? err : 'Desconhecido',
              variant: 'danger',
            },
          });
        });
    },
  },
};
</script>
<style lang="" scoped></style>
